import { render, staticRenderFns } from "./UploadPreVisualizacao.vue?vue&type=template&id=f0c2e328&scoped=true"
import script from "./UploadPreVisualizacao.vue?vue&type=script&lang=js"
export * from "./UploadPreVisualizacao.vue?vue&type=script&lang=js"
import style0 from "./UploadPreVisualizacao.vue?vue&type=style&index=0&id=f0c2e328&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0c2e328",
  null
  
)

export default component.exports